import {observable, computed, action} from 'mobx'
import {api} from 'helpers/Api'
import {toDate} from 'helpers/Format'

export interface ISubResult {
  sales: number
  tickets: number
  checkins: number
}

export interface IResult {
  total: ISubResult
  operarios: {[name: string]: ISubResult}

}
export default class {

  @observable resultSalesReport: IResult

  @computed
  get result() {
    return this.resultSalesReport
  }

  salesReport(range: string, from?, to?) {
    console.log('DashboardTicketStore - salesReport')
    if (range) {
      return api.post(`/tickets/totalsale/${range}`, {from, to}).then(totalSales => {
        console.log('DashboardTicketStore - totalSales: ', totalSales)
        return this.setResult(totalSales)
      })
    }

    return api.get(`/tickets/totalsale`).then(totalSales => {
      console.log('DashboardTicketStore - totalSales: ', totalSales)
      return this.setResult(totalSales)
    })
  }
  customerReport(range: string) {
    return api.get(`/tickets/salescustomers/${range}`).then(totals => totals )
  }

  @action
  private setResult(result: IResult) {
    this.resultSalesReport = result
    return this.resultSalesReport
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/modules/DashboardTicket/Store.ts